import request from '@/util/request'

// 保存个人项目
export const savePersonProject = (competitionId, data) => {
  return request({
    url: `/api/register/athlete/project/savePersonProject/${competitionId}`,
    method: 'POST',
    data
  })
}

// 保存集体项目
export const saveTeamProject = (competitionId, data) => {
  return request({
    url: `/api/register/athlete/project/saveTeamProject/${competitionId}`,
    method: 'POST',
    data
  })
}

// 保存对练项目
export const saveTrainProject = (competitionId, data) => {
  return request({
    url: `/api/register/athlete/project/saveTrainProject/${competitionId}`,
    method: 'POST',
    data
  })
}

// 删除对练项目分组
export const deleteTrainGroup = (data) => {
  return request({
    url: `/api/register/athlete/project/deleteTrainGroup`,
    method: 'POST',
    data
  })
}

// 个人项目申报列表-运动员已报项目列表
export const listByAthleteId = (data) => {
  return request({
    url: `/api/register/athlete/project/listByAthleteId`,
    method: 'GET',
    data
  })
}

// 集体项目申报列表-项目已报运动员列表
export const listTeamByProjectId = (data) => {
  return request({
    url: `/api/register/athlete/project/listTeamByProjectId`,
    method: 'GET',
    data
  })
}

// 对练项目申报列表-项目已报运动员列表
export const listTrainByProjectId = (data) => {
  return request({
    url: `/api/register/athlete/project/listTrainByProjectId`,
    method: 'GET',
    data
  })
}
